// extracted by mini-css-extract-plugin
export var askAiIcon = "_ok-9";
export var container = "_ok-0";
export var groupSeparator = "_ok-a";
export var highlight = "_ok-4";
export var resultIcon = "_ok-5";
export var resultItem = "_ok-7";
export var resultSubtitle = "_ok-3";
export var resultTitle = "_ok-2";
export var resultsList = "_ok-1";
export var searchGroup = "_ok-6";
export var selected = "_ok-8";